import { Box, TextField, Button, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { useParams, useNavigate, Navigate } from "react-router-dom";
import { GetAPI } from "../../Components/Backend/GetAPI";
import { PutAPI } from "../../Components/Backend/PutAPI";
import { usePermiteAcesso } from "../../Components/Funcionais/Utils";
import PageTitle from "../../Components/Layout/PageTitle";
import APIAxios from "../../Api/APIAxios";
import InputAdornment from "@mui/material/InputAdornment";
import ListIcon from "@mui/icons-material/List";
import GroupsIcon from "@mui/icons-material/Groups";
import InsertLinkIcon from '@mui/icons-material/InsertLink';

const MenuAlterar = () => {
  //***************************************   AVISOS E LOADING ************************************************* */
  // CONTROLE DE AVISOS E ALERTAS
  //Funcão para fechar avisos e alertas
  usePermiteAcesso(3); //Cadastro de Menu
  const [avisoErro, setAvisoErro] = useState("");
  const [avisoSucesso, setAvisoSucesso] = useState("");
  const [loading, setLoading] = useState(false);
  //************************************************************************************************** */

  const { id } = useParams();
  const apiAxios = APIAxios();
  const navigate = useNavigate();
  const [modulos, setModulos] = useState([]);

  const [formData, setFormData] = useState({
    adm: "",
    descricao: "",
    grupo: "",
    id: "",
    idEmpresa: "",
    tipo: "",
    valor: "",
  });

  const buscaMenu = async () => {
    setLoading(true);
    const response = await GetAPI(apiAxios, "/menu");
    setLoading(false);

    if (response.success) {
      setModulos(response.data);
    } else {
      setAvisoErro(response.errorMessage || "Erro ao carregar Menu.");
    }
  };

  useEffect(() => {
    buscarPerfil();
    if (id) {
      buscaMenu();
    }
  }, [id]);

  {
  }
  const buscarPerfil = async () => {
    setLoading(true);
    const response = await GetAPI(apiAxios, `/menu/${id}`);

    setLoading(false);

    if (response.success) {
      setFormData(response.data);
    } else {
      setAvisoErro(response.errorMessage || "Erro ao carregar perfil.");
    }
  };

  // Se o valor do campo for uma string, converte para maiúsculas
  const handleChange = (event, tam) => {
    const { name, value } = event.target;

    let valor = value;

    //Limita tamanho do campo
    if (typeof value === "string") {
      valor = valor.slice(0, tam);
    }

    setFormData((prevData) => ({
      ...prevData,
      [name]: valor,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    setLoading(true);
    const response = await PutAPI(apiAxios, "/menu", formData);
    setLoading(false);

    if (response.success) {
      setFormData(response.data);
      setAvisoSucesso("Menu atualizado com sucesso!");
    } else {
      setAvisoErro(
        response.errorMessage || "Erro ao atualizar menu.",
      );
    }
  };

  const handleVoltar = () => {
    navigate("/menu");
  };

  return (
    <div>
      {/******************************* TITULO E FUNCIONALIDADES *************************/}
      <PageTitle
        caption="Alterar Menu"
        setAvisoErro={setAvisoErro}
        avisoErro={avisoErro}
        avisoSucesso={avisoSucesso}
        setAvisoSucesso={setAvisoSucesso}
        loading={loading}
        accentStyle
      />
      {/**********************************************************************************/}
      <Box
        sx={{
          flexGrow: 1,
          padding: 3,
          justifyContent: "center",
        }}
      >
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            {/* Descrição */}
            <Grid item xs={12} md={12}>
              <TextField
                fullWidth
                label="Descrição:"
                variant="outlined"
                value={formData.descricao}
                onChange={(e) => handleChange(e, 50)}
                name="descricao"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <ListIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

            {/* Grupo */}
            <Grid item xs={12} md={12}>
              <TextField
                fullWidth
                label="Grupo:"
                variant="outlined"
                value={formData.grupo}
                onChange={(e) => handleChange(e, 50)}
                required
                name="grupo"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <GroupsIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

            {/* Tipo */}
            <Grid item xs={12} md={12}>
              <TextField
                fullWidth
                label="Tipo:"
                variant="outlined"
                value={formData.tipo}
                onChange={(e) => handleChange(e, 50)}
                disabled
                name="tipo"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <ListIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

            {/* Valor */}
            <Grid item xs={12} md={12}>
              <TextField
                fullWidth
                label="Endereço / Caminho:"
                variant="outlined"
                value={formData.valor}
                onChange={(e) => handleChange(e)}
                required
                name="valor"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <InsertLinkIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

            <Grid
              item
              xs={12}
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mt: 2,
              }}
            >
              <Box sx={{ display: "flex", gap: 1 }}>
                <Button
                  variant="contained"
                  size="large"
                  sx={{ backgroundColor: "#1a3865", xs: 12, md: 4 }}
                  onClick={handleVoltar}
                >
                  Voltar
                </Button>
              </Box>

              <Button
                variant="contained"
                color="primary"
                size="large"
                sx={{
                  backgroundColor: "#1a3865",
                  marginLeft: 2,
                  xs: 12,
                  md: 4,
                }}
                type="submit"
              >
                Salvar
              </Button>
            </Grid>
          </Grid>
        </form>
      </Box>
    </div>
  );
};

export default MenuAlterar;
